import { EFParams, ELocations } from '@enums/api.enum';
import { EStyles } from '@enums/style.enum';

import client from '../apiClient';

export type Location = {
	address: string;
	id: number;
	isWaitAndReturn: boolean;
	lat: number;
	lng: number;
	name: string;
	type: string;
	waitingTime: number;
};

export type LocationsParams = {
	limit?: number;
	page?: number;
	search?: string;
};

export type LocationsApiResponse = {
	records: Location[];
	totalResults: number;
	totalFiltersResults: number;
	totalPages: number;
	page: number;
};

const endpoint = ELocations.endpoint;

const get = <T>({ limit = 200, page = 1, search = EStyles.emptyQuote }: LocationsParams) => {
	const query = [EFParams.qm, EFParams.limit, limit, EFParams.and, EFParams.page, page, EFParams.and, EFParams.search, search].join(
		EStyles.emptyQuote,
	);

	return client.get<T>(`${endpoint}${query}`);
};

export default {
	get,
};
